import React from "react";
import styled from "styled-components";
import { experience } from "../../data/constants";

const Container = styled.section`
  display: flex;
  justify-content: center;
  padding: 40px 20px 10px;
`;

const Wrapper = styled.div`
  width: 100%;
  max-width: 1100px;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const Title = styled.h2`
  font-size: 42px;
  font-weight: 700;
  color: ${({ theme }) => theme.text_primary};
  text-align: center;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

const Desc = styled.p`
  font-size: 18px;
  line-height: 1.7;
  color: ${({ theme }) => theme.text_secondary};
  text-align: center;
  max-width: 760px;
  margin: 0 auto;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const Grid = styled.div`
  display: grid;
  gap: 18px;
  margin-top: 10px;
`;

const Card = styled.div`
  background: ${({ theme }) => theme.card};
  border: 1px solid rgba(253, 181, 21, 0.12);
  border-radius: 18px;
  padding: 24px;
  box-shadow: rgba(23, 92, 230, 0.12) 0px 4px 24px;
`;

const Head = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 10px;
`;

const Role = styled.h3`
  font-size: 22px;
  color: ${({ theme }) => theme.text_primary};
  margin: 0;
`;

const Company = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.primary};
  font-weight: 600;
`;

const Date = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.text_secondary};
`;

const Summary = styled.p`
  color: ${({ theme }) => theme.text_secondary};
  line-height: 1.7;
  margin: 8px 0 12px;
`;

const List = styled.ul`
  margin: 0;
  padding-left: 18px;
`;

const Item = styled.li`
  color: ${({ theme }) => theme.text_primary};
  line-height: 1.7;
  margin-bottom: 8px;
`;

const Experience = () => {
  return (
    <Container id="experience">
      <Wrapper>
        <Title>Experience</Title>
        <Desc>
          Selected professional experience across enterprise software platforms,
          production engineering systems, and scalable collaboration-oriented development.
        </Desc>

        <Grid>
          {experience.map((item) => (
            <Card key={item.id}>
              <Head>
                <div>
                  <Role>{item.role}</Role>
                  <Company>{item.company}</Company>
                </div>
                <Date>{item.date}</Date>
              </Head>

              <Summary>{item.summary}</Summary>

              <List>
                {item.bullets.map((bullet, index) => (
                  <Item key={index}>{bullet}</Item>
                ))}
              </List>
            </Card>
          ))}
        </Grid>
      </Wrapper>
    </Container>
  );
};

export default Experience;
